import React, { useEffect, useRef, useState } from "react";

import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import axios from "axios";
import ExcelView from "./Excel/ExcelView";
import AuthService from "../services/auth.service";
interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;
}

interface MemberListView {
  SelectValue: string;
  selectedClubInfo: ClubInfo | null;
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}
const MemberListView: React.FC<MemberListView> = ({ SelectValue, selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate }) => {
  const [selectmembercount, setselectmembercount] = useState<number>(0);
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedOption1, setSelectedOption1] = useState<string>("option1");
  const [searchOption, setSearchOption] = useState<string>("회원명");
  const [searchValue, setSearchValue] = useState<string>("");
  const [excelData, setExcelData] = useState<any[]>([]);
  const [isRotating, setIsRotating] = useState(false);
  const [tempexcelData, settempexcelData] = useState<any[]>([]);
  const [memberlistcolumncount, setmemberlistcolumncount] = useState<any>(0);
  const [memberlist, setmemberlist] = useState<any[]>([]);
  const [token, settoken] = useState<string | null>(null);
  const [addition, setaddition] = useState(0);
  const [membercount, setmembercount] = useState<number>(0);

  const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(
    null
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null); //엑셀뷰 선택한 데이터 행 출력
  const [selectedRowData, setSelectedRowData] = useState<any[] | null>(null);
  const [memberlistupdate, setmemberlistupdate] = useState<boolean>(false); // State for showing Excel view
  const [selectedValue, setSelectedValue] = useState("");
  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    setSelectedRowIndex(rowIndex);
    setSelectedRowData(rowData);
    const selectedRowData = excelData[rowIndex + 1];
  };

  useEffect(() => {
    if (token !== null) {

      fetchMemberlistDataAPI();

    }
  }, [token]);

  const onupdate = (value: boolean) => {
    setmemberlistupdate(value);
    fetchMemberlistDataAPI();
  };
  useEffect(() => {
    if (token !== null) {

      setSelectHeaderValue(SelectValue);

    }
  }, [SelectValue]);
  const onBox3Click = (clubNumber: string) => {

    const fetchMemberlistDataAPI = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/club/member/list/${clubNumber}?page=0&size=20000&sort=clubMemberSeq,desc`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        const formattedUserData: {
          name: string;
          memberGrade: string;
          mobileNumber: string;
          email: string;
          memberDataJson: string;
        }[] = [];
        response.data.data.content.forEach((item: any) => {
          const {
            memberName,
            memberGrade,
            mobileNumber,
            email,
            memberDataJson,
          } = item;
          const formattedData = {
            name: memberName,
            memberGrade: memberGrade,
            mobileNumber: mobileNumber,
            email: email, // 이 부분은 사용자 정보에 해당하는 이메일 데이터가 없어서 비워두었습니다.
            memberDataJson: memberDataJson,
          };
          formattedUserData.push(formattedData);
        });
        setmembercount(formattedUserData.length);
        if (formattedUserData.length > 1) {
        } else {
        }
      } catch (error) { }
    };

    fetchMemberlistDataAPI();
  };

  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const onSelectChange1 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value1 = event.target.value;
    setSelectedOption1(value1);
    setSearchOption(value1);
  };
  function calculateAge(birthDate: any) {
    const today = new Date();
    const birth = new Date(birthDate);

    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birth.getDate())
    ) {
      age--;
    }

    return age;
  }

  const fetchMemberlistDataAPI = async () => {
    try {
      if (selectedClubInfo?.club_seq !== undefined) {
        console.log(`${API_BASE_URL}/club/member/list/${selectedClubInfo?.club_seq}?page=0&size=2000&sort=clubMemberSeq,desc`)
        const response = await axios.get(
          `${API_BASE_URL}/club/member/list/${selectedClubInfo?.club_seq}?page=0&size=2000&sort=clubMemberSeq,desc`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        // console.log("(ExcelUpload) 맴버리스트 API Response:", response);

        let optioncount = 0;
        const formattedUserData: {
          name: string;
          memberGrade: string;
          mobileNumber: string;
          email: string;
          memberDataJson: string;
          localName: string;
          extraData: string;
        }[] = [];
        response.data.data.content.forEach((item: any) => {
          const {
            memberName,
            memberGrade,
            mobileNumber,
            email,
            memberDataJson,
            extraData,
            localName,
          } = item;
          const formattedData = {
            name: memberName,
            memberGrade: memberGrade,
            mobileNumber: mobileNumber,
            extraData: extraData,
            email: email,
            localName: localName,
            memberDataJson: memberDataJson,
          };

          formattedUserData.push(formattedData);
        });

        setmemberlist(formattedUserData);

        setselectmembercount(formattedUserData.length);
        // console.log("@@ : " +formattedUserData.length)





        setExcelData([]);
        let keysAdded = false; // Define a flag
        let executed = false;
        let memberheader: string[] = [];

        formattedUserData.forEach((item) => {
          const {
            name,
            memberGrade,
            mobileNumber,
            email,
            memberDataJson,
            extraData,
            localName,
          } = item;
          let memberjsondata;
          let memberjsonKeys;
          let memberjsonValues: string[] = [];

          let extrajsondata;
          let extrajsonKeys;
          let extrajsonValues: string[] = [];

          let addmemberjsondatakey: string[] = [];
          let addmemberjsondatavalues: unknown[] = [];

          let addextrajsondatakey: string[] = [];
          let addextrajsondatavalues: unknown[] = [];

          let formattedData: string[] = [];

          if (memberGrade !== "회장") {
            if (extraData !== null && extraData !== "" && extraData !== "{}") {
              // console.log("extraData 있음");
              // console.log("(ExcelUpload) extraDataJson : ", extraData);

              try {
                extrajsondata = JSON.parse(extraData);
                extrajsonKeys = Object.keys(extrajsondata);
                extrajsonValues = Object.values(extrajsondata);
              } catch (error) {
                console.error("Error parsing extraData:", error);
              }
              addextrajsondatakey = extrajsonKeys || [];
              addextrajsondatavalues = extrajsonValues || [];
              const extrajsonValues0 = JSON.stringify(extrajsonValues[0]);
              // console.log("타깃 : " + extrajsonValues0)
              try {
                const dataArray = JSON.parse(extrajsonValues0);
                formattedData = dataArray
                  .map(
                    (item: any) =>
                      `${item["관계"]} ${item["이름"]} ${
                        item["성별"] === "남" ? "M" : item["성별"] === "여" ? "F" : "U"
                      }/` + calculateAge(`${item["생년월일"]}`)

                      
                  )
                  .join("\n");
              } catch (error) {

              }
            } else {
              // console.log("extraData 없음");
              // setExcelData((prevData) => [...prevData,[name, mobileNumber, memberGrade, email,localName]]);
            }

            if (
              memberDataJson !== null &&
              memberDataJson !== "" &&
              memberDataJson !== "{}"
            ) {
              // console.log("memberdatajson 있음");
              // console.log("(ExcelUpload) memberDataJson", memberDataJson);

              try {
                memberjsondata = JSON.parse(memberDataJson);
                memberjsonKeys = Object.keys(memberjsondata);
                memberjsonValues = Object.values(memberjsondata);
              } catch (error) {
                console.error("Error parsing memberDataJson:", error);
              }

              // console.log(memberjsonKeys);
              // console.log(memberjsonValues);
              addmemberjsondatakey = memberjsonKeys || [];
              addmemberjsondatavalues = memberjsonValues || [];
            } else {
              // console.log("memberjsondata 없음");
              // setExcelData((prevData) => [...prevData,[name, mobileNumber, memberGrade, email,localName]]);
            }

            // console.log("확인 : " + formattedData);

            if (
              !formattedData ||
              (Array.isArray(formattedData) && formattedData.length === 0)
            ) {
              // console.log("가족없음");
              // console.log([
              //   "회원명",
              //   "핸드폰번호",
              //   "회원구분",
              //   "이메일",
              //   "localname",
              // ]);

              // console.log([name, mobileNumber, memberGrade, email, localName]);

              // if (!executed) {
              // setExcelData((prevData) => [...prevData,["회원명", "핸드폰번호", "회원구분", "이메일","localname"]]);
              if (
                memberheader.length <
                ["회원명", "핸드폰번호", "회원구분", "이메일", "아이디"]
                  .length
              ) {
                memberheader =
                  ["회원명", "핸드폰번호", "회원구분", "이메일", "아이디","가족"] ||
                  [];
              }

              // executed = true;
              // }
              setExcelData((prevData) => [
                ...prevData,
                [name, mobileNumber, memberGrade, email, localName],
              ]);
            } else {
              // if (!executed) {
              // setExcelData((prevData) => [...prevData,["회원명", "핸드폰번호", "회원구분", "이메일","localname", ...addmemberjsondatakey,...addextrajsondatakey]]);

              if (
                memberheader.length <
                [
                  "회원명",
                  "핸드폰번호",
                  "회원구분",
                  "이메일",
                  "아이디",
                  ...addmemberjsondatakey,
                  ...addextrajsondatakey,
                ].length
              ) {
                memberheader =
                  [
                    "회원명",
                    "핸드폰번호",
                    "회원구분",
                    "이메일",
                    "아이디",
                    ...addmemberjsondatakey,
                    ...addextrajsondatakey,
                  ] || [];
              }
              //   executed = true;
              // }

              const subtractCount =
                memberheader.length -
                [
                  "회원명",
                  "핸드폰번호",
                  "회원구분",
                  "이메일",
                  "localname",
                  ...addmemberjsondatakey,
                  ...addextrajsondatakey,
                ].length;
              if (
                memberheader.length >
                [
                  "회원명",
                  "핸드폰번호",
                  "회원구분",
                  "이메일",
                  "localname",
                  ...addmemberjsondatakey,
                  ...addextrajsondatakey,
                ].length
              ) {
                setExcelData((prevData) => [
                  ...prevData,
                  [
                    name,
                    mobileNumber,
                    memberGrade,
                    email,
                    localName,
                    ...Array(subtractCount).fill(""),
                    ...addmemberjsondatavalues,
                    formattedData,
                  ],
                ]);
              } else {
                setExcelData((prevData) => [
                  ...prevData,
                  [
                    name,
                    mobileNumber,
                    memberGrade,
                    email,
                    localName,
                    ...addmemberjsondatavalues,
                    formattedData,
                  ],
                ]);
              }
            }

            // console.log("최종적 header : " + memberheader);
            const sumOfLengths =
              (extrajsonValues || []).length + (memberjsonValues || []).length;
            // console.log(
            //   `(ExcelUpload) memberjson: ${(memberjsonValues || []).length}`
            // );
            // console.log(
            //   `(ExcelUpload) extrajson: ${(extrajsonValues || []).length}`
            // );
            // console.log(`(ExcelUpload) Sum of lengths: ${sumOfLengths}`);

            if (sumOfLengths > 1) {
              if (memberlistcolumncount === 0) {
                setmemberlistcolumncount(sumOfLengths);
              } else {
                if (memberlistcolumncount < sumOfLengths) {
                  setmemberlistcolumncount(sumOfLengths);
                }
              }
            }
          }
        });

        setExcelData((prevData) => [memberheader, ...prevData]);
        if(formattedUserData.length===1){
          const excelHeader = ["회원명", "핸드폰번호", "회원구분", "이메일","아이디"];
    
          // 엑셀 데이터 업데이트 (헤더만 추가)
          setExcelData([excelHeader]);
      
          // 빈 행 추가
          for (let i = 0; i < 1000; i++) {
            setExcelData((prevData) => [...prevData, []]);
          }
        }

        // console.log("최종 추가 열개수 : " + (memberlistcolumncount))

      }
    } catch (error) {
      console.error("Error:", error);
    }

    for (let i = 0; i < 1000; i++) {
      setExcelData((prevData) => [...prevData, []]);
    }

    // console.log('실행');
  };
  const handleRotate = () => { //새로고침
    setIsRotating(true);
    console.log("새로고침 실행")

    setExcelData([]);
    fetchMemberlistDataAPI();

    setTimeout(() => setIsRotating(false), 500); // 3초 후에 회전을 멈춥니다.
  };
  const handleExcelrowClick = (value: any) => {
    // console.log("(ExcelUpload) 찾아온 데이터:", value);
    setSelectedValue(value);
  };
  const onSearchClick = async () => {
    ///검색기능
    // console.log("전체엑셀데이터:", excelData);
    // console.log("검색옵션 :", searchOption);
    // console.log("검색값:", searchValue);
    const excelHeader = excelData[0];

    if (searchValue === "") {
      // console.log("(ExcelUpload) 빈값" + excelData);
      // console.log("(ExcelUpload) 저장한값" + tempexcelData);
      setExcelData([]);
      setExcelData(tempexcelData);
      for (let i = 0; i < 1000; i++) {
        setExcelData((prevData) => [...prevData, []]);
      }
    } else {
      settempexcelData(excelData);
      // 검색 옵션과 검색 값으로 회원 찾기
      const foundMembers = excelData.filter((row) => {
        if (searchOption === "회원명" || searchOption === "name") {
          return row[0] === searchValue;
        } else if (searchOption === "phone") {
          return row[1] === searchValue;
        } else if (searchOption === "memberGrade") {
          return row[2] === searchValue;
        } else if (searchOption === "email") {
          return row[3] === searchValue;
        } else if (searchOption === "localname") {
          return row[4] === searchValue;
        }
        return false;
      });

      if (foundMembers.length === 0) {
        window.alert("검색결과가 없습니다.");
        return; // Exit early, no further action needed
      } else {
        // console.log("찾은 회원들:", foundMembers);
        setExcelData([excelHeader, ...foundMembers]);
        for (let i = 0; i < 1000; i++) {
          setExcelData((prevData) => [...prevData, []]);
        }
      }
    }
  };
  return (

    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px" }}>
      <div style={{ fontSize: "24px" }}>
        | { } 명단
      </div>
      <div
        style={{
          padding: "5px",
          border: "1px solid #CACACA",
          marginLeft: "80px",
          marginBottom: "55px",
          width: width <= 1600 ? "500px" : "700px",
          marginTop: "50px",
        }}
      >

        <select
          value={selectedOption1}
          onChange={onSelectChange1}
          style={{
            border: "none",
            borderRadius: "5px",
            backgroundColor: "rgba(255, 255, 255, 0)",
            fontSize: "16px",
            cursor: "pointer",
            outline: "none",
          }}
        >
          <option
            value="name"
            style={{ color: "black", borderRadius: "5px" }}
          >
            회원명
          </option>
          <option
            value="phone"
            style={{ color: "black", borderRadius: "5px" }}
          >
            핸드폰번호
          </option>
          <option
            value="memberGrade"
            style={{ color: "black", borderRadius: "5px" }}
          >
            회원구분
          </option>
          <option
            value="email"
            style={{ color: "black", borderRadius: "5px" }}
          >
            이메일
          </option>
          <option
            value="localname"
            style={{ color: "black", borderRadius: "5px" }}
          >
            아이디
          </option>
        </select>
        |
        <Input
          value={searchValue}
          onChange={onInputChange}
          style={{
            width: width <= 1600 ? "200px" : "490px",
            height: "30px",
            marginRight: "10px",
            border: "none",
          }}
          placeholder="회원 검색"
          prefix={<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
        />
        <button
          style={{
            cursor: "pointer",
            width: "50px",
            height: "30px",
            borderRadius: "10px",
            backgroundColor: "#ffff",
            border: "1px solid #2D5478", // Set border color and thickness
            color: "#000",
          }}
          onClick={onSearchClick}
        >
          찾기
        </button>

      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "left",
            fontSize: "30px",
            paddingLeft: "50px",
            width: "800px"
          }}
        >
          <div>
            회원명단({selectmembercount - 1 === -1 ? 0 : selectmembercount - 1}명)
          </div>

          <img
            src="asset/img/refresh.png"
            alt="Refresh Icon"
            onClick={handleRotate}

            className={isRotating ? "rotate" : ""}
            style={{
              width: width <= 1600 ? "30px" : "50px",
              height: width <= 1600 ? "30px" : "50px",

              cursor: "pointer",
              marginLeft: "10px",
              transition: "transform 1s linear",
              transform: isRotating ? "rotate(1500deg)" : "rotate(0deg)"
              // transform: isRotating ? "rotate(900deg)" : "rotate(0deg)"

            }}
          />
        </div>


      </div>
      <div style={{ width: "100%", height: "800px" }}>

        <ExcelView
          data={excelData}
          addition={addition || 0}
          membercount={membercount || 0}
          SelectValue={SelectHeaderValue || ""}
          memberlistcolumncount={memberlistcolumncount || 0}
          selectedClubInfo={selectedClubInfo?.club_seq || 0}
          onRowSelect={handleRowSelect}
          onupdate={onupdate}
          onExcelrowClick={handleExcelrowClick}

        />
      </div>
    </div>






  );

};

export default MemberListView;
